<div>
  <div class="container-fluid">
    <!-- Page Header -->
    <div class="row mb-4">
      <div class="col-md-6">
        <h1 class="h2 mb-1 fw-bold">Agremo Analyses</h1>
        <p class="text-muted">View all analyses across all organizations</p>
      </div>
    </div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
      <i class="bi bi-check-circle-fill me-2"></i>
      {{ successMessage }}
      <button type="button" class="btn-close" aria-label="Close" (click)="successMessage = ''"></button>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''"></button>
    </div>

    <!-- Filters -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="row g-3">
          <!-- Organization Filter -->
          <div class="col-md-3">
            <label class="form-label small text-body-secondary">Organization ID</label>
            <input
              type="text"
              class="form-control"
              placeholder="Filter by organization ID..."
              [(ngModel)]="filterOrganizationId"
              (keyup.enter)="onFilterChange()"
            />
          </div>

          <!-- Status Filter -->
          <div class="col-md-3">
            <label class="form-label small text-body-secondary">Status</label>
            <select class="form-select" [(ngModel)]="filterStatus" (change)="onFilterChange()">
              <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>

          <!-- Start Date Filter -->
          <div class="col-md-3">
            <label class="form-label small text-body-secondary">Start Date</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="filterStartDate"
              (change)="onFilterChange()"
            />
          </div>

          <!-- End Date Filter -->
          <div class="col-md-3">
            <label class="form-label small text-body-secondary">End Date</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="filterEndDate"
              (change)="onFilterChange()"
            />
          </div>
        </div>

        <!-- Clear Filters Button -->
        <div class="row mt-3" *ngIf="hasActiveFilters()">
          <div class="col-12">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">
              <i class="bi bi-x-circle me-1"></i>
              Clear Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Analyses Table -->
    <div *ngIf="!loading" class="card overflow-hidden">
      <div class="table-responsive">
        <table class="table data-table table-hover mb-0">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Field</th>
              <th>Analysis Type</th>
              <th>Status</th>
              <th>Requested</th>
              <th>Completed</th>
              <th>Credits</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="analyses.length === 0">
              <td colspan="8" class="text-center text-muted py-4">
                No analyses found
              </td>
            </tr>
            <tr *ngFor="let analysis of analyses" class="cursor-pointer" (click)="viewAnalysis(analysis)">
              <td>
                <div class="d-flex align-items-center gap-3">
                  <div class="entity-avatar">
                    <i class="bi bi-building"></i>
                  </div>
                  <div>
                    <div class="fw-medium">{{ analysis.organizationName || '-' }}</div>
                  </div>
                </div>
              </td>
              <td>{{ analysis.fieldName || '-' }}</td>
              <td>{{ analysis.analysisTypeName || analysis.analysisTypeId || '-' }}</td>
              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(analysis.status)">
                  {{ getStatusLabel(analysis.status) }}
                </span>
              </td>
              <td>{{ formatDateTime(analysis.requestedAt) }}</td>
              <td>{{ formatDateTime(analysis.completedAt) }}</td>
              <td>{{ analysis.creditsConsumed }}</td>
              <td>
                <button
                  *ngIf="canRetryDownload(analysis)"
                  class="btn btn-sm btn-outline-primary"
                  [disabled]="retryingId !== null"
                  (click)="retryDownload(analysis); $event.stopPropagation()"
                  title="Re-download result files from Agremo"
                >
                  <span *ngIf="retryingId === analysis.id" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  <i *ngIf="retryingId !== analysis.id" class="bi bi-arrow-clockwise me-1"></i>
                  Retry Download
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="card-footer" *ngIf="totalPages > 1">
        <div class="d-flex justify-content-between align-items-center">
          <div class="text-muted small">
            Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalAnalyses) }} of {{ totalAnalyses }} analyses
          </div>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="goToPage(currentPage - 1)">
                  <i class="bi bi-chevron-left"></i>
                </a>
              </li>
              <li
                *ngFor="let page of paginationRange"
                class="page-item"
                [class.active]="page === currentPage"
              >
                <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="goToPage(currentPage + 1)">
                  <i class="bi bi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
